import { stdObject } from "../data/types/stdObject";
import { sendData } from "./sendData";

export const savePaymentsInfo = async (
  data: stdObject,
  payTypesList: stdObject[],
  logoutAction: any,
) => {
  try {
    data.info.ABO = data.records
      .filter((e: stdObject) => !e.delete)
      .reduce((acc: number, item: stdObject) => acc + item.CANDIN, 0);
    data.info.SAL = data.info.TOT - data.info.ABO;
    const payTypes = data.records.reduce((acc: stdObject, item: stdObject) => {
      if (!(item.TIPDIN in acc)) {
        acc[item.TIPDIN] =
          payTypesList.find((e: stdObject) => e.CODTPA === item.TIPDIN)
            ?.NOMTPA ?? item.TIPDIN;
      }
      return acc;
    }, {});
    const payloadPayments = {
      info: data.info,
      type: data.type,
      payTypes,
      insert: data.records
        .filter((e: stdObject) => !e.ID && !e.delete)
        .map((e: stdObject) => {
          if ("delete" in e) {
            delete e.delete;
          }
          return Object.entries(e);
        }),
      update: data.records
        .filter((e: stdObject) => e.ID && !e.delete)
        .map((e: stdObject) => {
          if ("delete" in e) {
            delete e.delete;
          }
          return Object.entries(e);
        }),
      delete: data.records
        .filter((e: stdObject) => e.ID && e.delete)
        .map((e: stdObject) => {
          if ("delete" in e) {
            delete e.delete;
          }
          return e;
        }),
    };
    const responsePayments: stdObject = await sendData({
      endPoint: "savePayments",
      payload: payloadPayments,
      logoutAction,
    });
    if (responsePayments.success && responsePayments.status) {
      return { type: responsePayments.type, data: responsePayments.data };
    }
  } catch (error) {
    console.log("savePaymentsInfo error: ", error);
  }
  return { error: "error" };
};
